import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import Slider from "react-slick";
import { all_routes } from "../../router/all_routes";
// Helpers for password validation
const hasNumber = (value) => /[0-9]/.test(value);
const hasMixed = (value) => /[a-z]/.test(value) && /[A-Z]/.test(value);
const hasSpecial = (value) => /[!#@$%^&*)(+=._-]/.test(value);
const strengthColor = (count) => {
  if (count <= 1) return "poor";
  if (count === 2) return "weak";
  if (count === 3) return "strong";
  if (count >= 4) return "heavy";
  return "poor";
};

const Register = () => {
  const [eye, setEye] = useState(true);
  const [eyeConfirmPassword, setEyeConfirmPassword] = useState(true);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [validationError, setValidationError] = useState(0);
  const [strength, setStrength] = useState("");
  const [message, setMessage] = useState("");
  const [responseMessage, setResponseMessage] = useState(false);
  const [isAgreed, setIsAgreed] = useState(false);
  const [isAgreementError, setIsAgreementError] = useState(false);

  const navigate = useNavigate();
  const handlePasswordChange = (e) => {
    const val = e.target.value;
    setPassword(val);
    validatePassword(val);
  };

  const validatePassword = (val) => {
    if (!val) return setValidationError(1);
    if (val.length < 8) return setValidationError(2);
    if (!hasNumber(val)) return setValidationError(3);
    if (!hasSpecial(val)) return setValidationError(4);
    setValidationError(5);
  };

  const strengthIndicator = (val) => {
    let count = 0;
    if (val.length >= 8) count++;
    if (hasNumber(val)) count++;
    if (hasSpecial(val)) count++;
    if (hasMixed(val)) count++;
    return count;
  };

  useEffect(() => {
    if (password) {
      const count = strengthIndicator(password);
      const color = strengthColor(count);
      setStrength(color);
    } else {
      setStrength("");
    }
  }, [password]);

  const messages = () => {
    switch (validationError) {
      case 2:
        return (
          <span style={{ color: "#DC3545" }}>
            Weak. Must contain at least 8 characters.
          </span>
        );
      case 3:
        return (
          <span style={{ color: "#FFC107" }}>
            Average. Must contain at least 1 number.
          </span>
        );
      case 4:
        return (
          <span style={{ color: "#0D6EFD" }}>
            Almost. Must contain a special symbol.
          </span>
        );
      case 5:
        return (
          <span style={{ color: "#4BB543" }}>
            Awesome! You have a secure password.
          </span>
        );
      default:
        return null;
    }
  };

  const loginSlider = {
    dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
  };

  const redirectToGoogle = () => {
    const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;
    const redirectUri = encodeURIComponent(
      "https://finedu.microcodesoftware.com/google-callback"
    );
    const scope = encodeURIComponent("email profile");
    const responseType = "code";

    window.location.href =
      `https://accounts.google.com/o/oauth2/v2/auth?client_id=${clientId}` +
      `&redirect_uri=${redirectUri}&response_type=${responseType}&scope=${scope}`;
  };

  return (
    <div className="main-wrapper">
      <div className="login-content">
        <div className="row">
          <div className="col-md-6 login-bg d-none d-lg-flex">
            <div className="">
              <div className="login-carousel-section mb-3">
                <div className="login-banner">
                  <ImageWithBasePath
                    src="assets/img/auth/auth-1.svg"
                    className="img-fluid"
                    alt="Logo"
                  />
                </div>
                <div className="mentor-course text-center">
                  <h3 className="mb-2">
                    Welcome to{" "}
                    <span className="text-secondary">AIATI in India.</span>{" "}
                  </h3>
                  <p>
                    A trusted platform to manage, deliver, and track aviation
                    learning .
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-6 login-wrap-bg">
            <div className="login-wrapper">
              <div className="loginbox">
                <div className="w-100">
                  <div className="d-flex align-items-center justify-content-between login-header mb-3">
                    <Link to="/index-4">
                      <ImageWithBasePath
                        src="assets/img/logo.png"
                        className="img-fluid"
                        alt="Logo"
                      />
                    </Link>
                    <Link to={all_routes.homeone} className="link-1">
                      Back to Home
                    </Link>
                  </div>

                  <h1 className="fs-32 fw-bold">Sign up</h1>

                  {message && (
                    <div
                      className={`mb-3 ${
                        responseMessage ? "text-success" : "text-danger"
                      }`}
                    >
                      {message}
                    </div>
                  )}

                  <form>
                    <div className="mb-3">
                      <label className="form-label">
                        Full Name <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                      />
                    </div>

                    <div className="mb-3">
                      <label className="form-label">
                        Email <span className="text-danger">*</span>
                      </label>
                      <input
                        type="email"
                        className="form-control"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                    </div>

                    <div className="mb-3">
                      <label className="form-label">
                        Password <span className="text-danger">*</span>
                      </label>
                      <input
                        type={eye ? "password" : "text"}
                        className="form-control"
                        value={password}
                        onChange={handlePasswordChange}
                      />
                      <span
                        onClick={() => setEye(!eye)}
                        style={{
                          cursor: "pointer",
                          position: "absolute",
                          right: "10px",
                          top: "50%",
                        }}
                      >
                        {eye ? "👁️‍🗨️" : "👁️"}
                      </span>
                      <div className={`password-strength ${strength}`}></div>
                      {messages()}
                    </div>

                    <div className="mb-3">
                      <label className="form-label">
                        Confirm Password <span className="text-danger">*</span>
                      </label>
                      <input
                        type={eyeConfirmPassword ? "password" : "text"}
                        className="form-control"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                      />
                      <span
                        onClick={() =>
                          setEyeConfirmPassword(!eyeConfirmPassword)
                        }
                        style={{
                          cursor: "pointer",
                          position: "absolute",
                          right: "10px",
                          top: "50%",
                        }}
                      >
                        {eyeConfirmPassword ? "👁️‍🗨️" : "👁️"}
                      </span>
                    </div>

                    <div className="mb-3 form-check">
                      <input
                        className={`form-check-input ${
                          isAgreementError ? "border border-danger" : ""
                        }`}
                        type="checkbox"
                        checked={isAgreed}
                        onChange={() => {
                          setIsAgreed(!isAgreed);
                          setIsAgreementError(false);
                        }}
                      />
                      <label className="form-check-label">
                        I agree to the{" "}
                        <Link to={all_routes.termsConditions}>
                          Terms of Service
                        </Link>{" "}
                        and{" "}
                        <Link to={all_routes.privacyPolicy}>
                          Privacy Policy
                        </Link>
                      </label>
                      {isAgreementError && (
                        <div className="text-danger">
                          You must agree before submitting.
                        </div>
                      )}
                    </div>

                    <div className="d-grid">
                      <button className="btn btn-secondary" type="submit">
                        Sign Up
                      </button>
                    </div>
                  </form>

                  <div className="text-center my-3">Or</div>
                  <div className="d-flex justify-content-center">
                    <button
                      className="btn btn-light"
                      onClick={redirectToGoogle}
                    >
                      <ImageWithBasePath
                        src="assets/img/icons/google.svg"
                        className="me-2"
                        alt="Google"
                      />{" "}
                      Google
                    </button>
                  </div>

                  <div className="text-center mt-3">
                    Already have an account?{" "}
                    <Link to={all_routes.login}>Login</Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Register;
